export default __webpack_public_path__ + "static/media/menu-logo.66bf83f3.svg";